// components/globe/DetailsPanel.js
import React from "react";

const DetailsPanel = ({ cityInfo, onClose, weather }) => {
  if (!cityInfo) return null;

  return (
    <div
      style={{
        position: "absolute",
        left: "50%",
        transform: "translateX(-50%)",
        bottom: 24,
        zIndex: 30,
        width: "min(92vw, 440px)",
        background: "rgba(255,255,255,0.92)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        border: "1px solid rgba(0,0,0,0.08)",
        borderRadius: 16,
        boxShadow: "0 12px 30px rgba(0,0,0,0.25)",
        overflow: "hidden",
      }}
    >
      {/* header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "12px 14px",
          background:
            "linear-gradient(180deg, rgba(248,250,252,0.9) 0%, rgba(255,255,255,0.6) 100%)",
          borderBottom: "1px solid rgba(0,0,0,0.06)",
        }}
      >
        <div style={{ fontWeight: 700, fontSize: 16, color: "#0f172a" }}>
          {cityInfo.name}
        </div>
        <button
          onClick={onClose}
          style={{
            border: 0,
            background: "#ef4444",
            color: "white",
            padding: "6px 10px",
            borderRadius: 10,
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          Close
        </button>
      </div>

      {/* body */}
      <div style={{ padding: 14 }}>
        {cityInfo.summary && (
          <p style={{ margin: 0, color: "#111827", lineHeight: 1.5 }}>
            {cityInfo.summary}
          </p>
        )}

        {weather && (
          <div
            style={{
              marginTop: 12,
              display: "flex",
              alignItems: "center",
              gap: 8,
              padding: "10px 12px",
              borderRadius: 12,
              background: "#f1f5f9",
              border: "1px solid #e2e8f0",
              fontSize: 13,
              color: "#0f172a",
            }}
          >
            <span style={{ fontSize: 16 }}>🌤️</span>
            <strong style={{ marginRight: 6 }}>Weather:</strong>
            <span>{weather.text}</span>
          </div>
        )}

        {cityInfo.bestTime && (
          <div
            style={{
              marginTop: 10,
              display: "flex",
              alignItems: "center",
              gap: 8,
              padding: "10px 12px",
              borderRadius: 12,
              background: "#ecfeff",
              border: "1px solid #a5f3fc",
              fontSize: 13,
              color: "#075985",
            }}
          >
            <span style={{ fontSize: 16 }}>🏷️</span>
            <strong style={{ marginRight: 6 }}>Best time:</strong>
            <span>{cityInfo.bestTime}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DetailsPanel;
